function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5B9A\\u7A3F",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u9F99\\u8725\\u5B9E\\u9A8C\\u5BA4",
  transform: "translate(-1174.000000, -1364.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-7",
  transform: "translate(0.000000, 1166.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u8D44\\u6E90\\u670D\\u52A1",
  transform: "translate(1175.000000, 198.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#EBECEC",
  fillRule: "nonzero",
  points: "31.9067618 7.09835975 10.7321193 19.3234485 10.7321193 43.773626 31.9067618 55.9987148 53.0806155 43.773626 53.0806155 19.3234485"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.1822968,3.15486162 C35.1822968,4.89713393 33.7697075,6.30972322 32.0274352,6.30972322 C30.2851629,6.30972322 28.8725736,4.89713393 28.8725736,3.15486162 C28.8725736,1.41258929 30.2851629,0 32.0274352,0 C33.7697075,0 35.1822968,1.41258929 35.1822968,3.15486162",
  id: "Fill-10",
  fill: "#1C8AEC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.15468849,18.1404542 C9.15468849,19.8827266 7.7420992,21.2953159 5.99982688,21.2953159 C4.25755455,21.2953159 2.84496527,19.8827266 2.84496527,18.1404542 C2.84496527,16.3981819 4.25755455,14.9855926 5.99982688,14.9855926 C7.7420992,14.9855926 9.15468849,16.3981819 9.15468849,18.1404542",
  id: "Fill-10\\u5907\\u4EFD-2",
  fill: "#1C8AEC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2099051,18.1404542 C61.2099051,19.8827266 59.7973158,21.2953159 58.0550435,21.2953159 C56.3127711,21.2953159 54.9001818,19.8827266 54.9001818,18.1404542 C54.9001818,16.3981819 56.3127711,14.9855926 58.0550435,14.9855926 C59.7973158,14.9855926 61.2099051,16.3981819 61.2099051,18.1404542",
  id: "Fill-10\\u5907\\u4EFD-4",
  fill: "#1C8AEC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.15468849,44.1680625 C9.15468849,45.9103348 7.7420992,47.3229241 5.99982688,47.3229241 C4.25755455,47.3229241 2.84496527,45.9103348 2.84496527,44.1680625 C2.84496527,42.4257902 4.25755455,41.0132009 5.99982688,41.0132009 C7.7420992,41.0132009 9.15468849,42.4257902 9.15468849,44.1680625",
  id: "Fill-10\\u5907\\u4EFD-3",
  fill: "#1C8AEC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2099051,43.3793472 C61.2099051,45.1216195 59.7973158,46.5342088 58.0550435,46.5342088 C56.3127711,46.5342088 54.9001818,45.1216195 54.9001818,43.3793472 C54.9001818,41.6370749 56.3127711,40.2244856 58.0550435,40.2244856 C59.7973158,40.2244856 61.2099051,41.6370749 61.2099051,43.3793472",
  id: "Fill-10\\u5907\\u4EFD-5",
  fill: "#1C8AEC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.1822968,60.7310861 C35.1822968,62.4733584 33.7697075,63.8859477 32.0274352,63.8859477 C30.2851629,63.8859477 28.8725736,62.4733584 28.8725736,60.7310861 C28.8725736,58.9888136 30.2851629,57.5762244 32.0274352,57.5762244 C33.7697075,57.5762244 35.1822968,58.9888136 35.1822968,60.7310861",
  id: "Fill-10\\u5907\\u4EFD",
  fill: "#1C8AEC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-2",
  strokeLinecap: "square",
  transform: "translate(10.500641, 5.619598)",
  stroke: "#EBECEC",
  strokeWidth: 0.804878049
}, /*#__PURE__*/React.createElement("line", {
  x1: 18.4662135,
  y1: -1.08792879e-15,
  x2: 0,
  y2: 10.8448368,
  id: "\\u76F4\\u7EBF"
}), /*#__PURE__*/React.createElement("line", {
  x1: 42.8221099,
  y1: 41.703327,
  x2: 24.6816556,
  y2: 52.153806,
  id: "\\u76F4\\u7EBF\\u5907\\u4EFD"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#62B2F9",
  fillRule: "nonzero",
  points: "16.132217 40.5039012 16.132217 22.626352 31.9065251 31.5651265 31.9065251 49.4426757"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  fill: "#A1CDF4",
  fillRule: "nonzero",
  points: "32.0274352 13.4081618 47.8017433 22.478389 32.0274352 31.5486162 16.2531271 22.478389"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#1C8AEC",
  fillRule: "nonzero",
  points: "47.6808332 40.5039012 47.6808332 22.626352 31.9065251 31.5651265 31.9065251 49.4426757"
}), /*#__PURE__*/React.createElement("line", {
  x1: 15.7345063,
  y1: 26.5980037,
  x2: -4.93176996e-10,
  y2: 35.6823252,
  id: "\\u76F4\\u7EBF",
  stroke: "#EBECEC",
  strokeWidth: 0.804878049,
  strokeLinecap: "square",
  transform: "translate(7.867253, 31.140164) rotate(-60.000000) translate(-7.867253, -31.140164) "
}), /*#__PURE__*/React.createElement("line", {
  x1: 64,
  y1: 26.0492404,
  x2: 48.3226829,
  y2: 35.1005436,
  id: "\\u76F4\\u7EBF\\u5907\\u4EFD",
  stroke: "#EBECEC",
  strokeWidth: 0.804878049,
  strokeLinecap: "square",
  transform: "translate(56.161341, 30.574892) rotate(-60.000000) translate(-56.161341, -30.574892) "
})))));

function SvgDecorativeIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "64px",
    viewBox: "0 0 66 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8D44\u6E90\u670D\u52A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeIcon5);
export default __webpack_public_path__ + "static/media/decorative-icon-5.05adc561.svg";
export { ForwardRef as ReactComponent };